module.exports = __webpack_public_path__ + "img/fire-flame-13.cc5e2673.png";